import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Image } from '../../../common/image'
import classes from '../../index.module.scss'
import chaseMoneyIcon from './icon/chaseMoney.svg'
import { Loading } from '../../../common/loading'

export const PayNowButton = ({ onClick, title, disabled, loading }) => {
  return (
    <Element
      style={{
        backgroundColor: '#3DA967',
        color: '#FFFFFF',
        opacity: disabled || loading ? 0.6 : 'unset',
      }}
      className={classes.btnPayNow}
      onClick={!disabled ? onClick : () => {}}
    >
      {loading && <Loading />}
      <Image
        src={chaseMoneyIcon}
        alt="chaseMoney"
        style={{ width: 18, height: 18, marginRight: 8 }}
      />
      <Translate value={title} />
    </Element>
  )
}
